module.exports = __webpack_public_path__ + "img/me.94ca2c16.png";